import request from '@/utils/request.ts'
// export const addEquipment = (params: any) =>
//   request({
//     url: '/api/addequip',
//     method: 'post',
//     data: params,
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   })
export const addEquipment = (params: any) =>
  request({
    url: '/devices/adddevice',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// export const getlist = (params: any) =>
//   request({
//     url: '/api/equipregulate',
//     method: 'post',
//     data: params,
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   })
export const getlist = (params: any) =>
  request({
    url: '/devices/getDeviceList',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// export const updateinfo = (params: any) =>
//   request({
//     url: '/api/equipmanage',
//     method: 'put',
//     data: params,
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   })
export const updateinfo = (params: any) =>
  request({
    url: '/devices/updateDeviceList',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// export const getdatainfo = (params: any) =>
//   request({
//     url: '/api/getequipinfo',
//     method: 'post',
//     data: params,
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   })
export const getdatainfo = (params: any) =>
  request({
    url: '/devices/getDeviceByID',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const getalldatalist = (params: any) =>
  request({
    url: '/api/getalllist',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const uploadfile = (params: any) =>
  request({
    url: '/devices/uploadfile',
    method: 'post',
    data: params,

  })
export const getequiptypelist = (params: any) =>
  request({
    url: '/devicetype/getlistbycondition',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const downloadFile = (params: any) =>
  request({
    url: '/devices/download',
    method: 'get',
    params
  })

